/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seat_Change_Description_MinimumInputs */



/**
* | output |
* | --- |
* | "Base seats are the seats you always pay for, even when nobody uses them. You see the price before anything is changed." |
*
* @param {Seat_Change_Description_MinimumInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const seat_change_description_minimum = /** @type {((inputs?: Seat_Change_Description_MinimumInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seat_Change_Description_MinimumInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Basisplätze sind die Plätze, die Sie immer bezahlen – auch wenn sie niemand nutzt. Sie sehen den Preis, bevor etwas geändert wird.")
	return /** @type {LocalizedString} */ ("Base seats are the seats you always pay for, even when nobody uses them. You see the price before anything is changed.")
});